<div class="ctr">
  <div class="anim end"></div>
</div>
